import {momentDay} from "./moment-with-helpers"

export function orderInPreparation() {
    return this.order.status === 'IN_PREPARATION' || this.order.status === 'READY';
}

export function orderEditable() {
    return this.order.status === 'WAITING' || this.order.status === 'IN_PREPARATION' || this.order.status === 'READY';
}

export function orderProductsQuantitiesEditable() {
    const finalCustomerType = this.order.final_customer_type || null;
    if (finalCustomerType === 'short_channel' || finalCustomerType === 'pickup_point') {
        return false
    }
    return this.orderEditable && !this.order.paid_at;
}

export function orderReady() {
    return this.order.status === 'READY';
}

export function orderDone() {
    return this.order.status === 'DONE';
}

export function orderCancelled() {
    return this.order.status === 'CANCELLED';
}

export function orderContainersValid() {
    return this.order.containers && this.order.containers.length > 0;
}

export function orderReadyOrDone() {
    return this.order.status === 'READY' || this.order.status === 'DONE';
}

export function orderReadyDoneOrInvoiced() {
    return this.order.status === 'READY' || this.order.status === 'DONE' || this.order.status === 'INVOICED';
}

export function formattedDeliveryDate() {
    return momentDay(this.deliveryDate.date).format('dddd Do MMMM YYYY');
}

export function formattedEndPreparationDate() {
    return momentDay(this.endPreparationDate.date).format('dddd Do MMMM YYYY');
}

export function orderedProductsByMainCategory() {
    let productsByCategory = {};

    if(this.orderedProducts) {
        for (const sku in this.orderedProducts) {
            const product = this.orderedProducts[sku];
            const productSku = product['sku'];
            const categoryId = product['fk_category'] ? product['fk_category'] : 0;
            const mainCategory = this.categoriesMainCategory[categoryId];
            const mainCategoryId = mainCategory['id'];
            const category = this.categoriesById[categoryId];
            if(!productsByCategory[mainCategoryId]) {
                productsByCategory[mainCategoryId] = {
                    'category': mainCategory,
                    'productsBySubCategory': {},
                    'products': {},
                };
            }
            if(!productsByCategory[mainCategoryId]['productsBySubCategory'][categoryId]) {
                productsByCategory[mainCategoryId]['productsBySubCategory'][categoryId] = {
                    'category': category,
                    'products': {},
                };
            }
            productsByCategory[mainCategoryId]['products'][productSku] = product;
            productsByCategory[mainCategoryId]['productsBySubCategory'][categoryId]['products'][productSku] = product;
        }
    }
    return Object
        .values(productsByCategory)
        .sort((a, b) => a.category.order - b.category.order);
}
